import { EntityState } from '@ngrx/entity';
import * as adapters from './wellness.adapters';
import { Wellness, API } from '@app/core/models';

export interface State {
  hotels: Wellness.Hotel[];
  completionReports: EntityState<Wellness.CompletionReportEntity>;
  risks: Wellness.Risk[];
  menu: Wellness.Menu | null;
  api: {
    getTeamWellnessChecksHotels: API.LoadingState;
    getTeamWellnessCheckInReport: API.LoadingState;
    getTeamWellnessCheckInRisks: API.LoadingState;
  };
}

export const initialState: State = {
  hotels: [],
  completionReports: adapters.completionReports.getInitialState(),
  risks: [],
  menu: null,
  api: {
    getTeamWellnessChecksHotels: API.LoadingState.INIT,
    getTeamWellnessCheckInReport: API.LoadingState.INIT,
    getTeamWellnessCheckInRisks: API.LoadingState.INIT,
  },
};
